import { StopTimeType } from "types/MultiStop";
import { ScheduleStopValue } from "pages/shipper/RequestFormV2/defaults/scheduleDefaults";
import { formatStopSummaryDateTime } from "pages/shipper/RequestFormV2/sections/Schedule/utils/scheduleDateTime";

export function formatStopLocation(stop?: ScheduleStopValue, countryCode?: string): string {
  if (!stop) return "";
  const parts = [stop.city_name, countryCode].filter(Boolean);
  return parts.join(", ");
}

export function formatStopScheduleDateTime(stop?: ScheduleStopValue): string {
  if (!stop) return "";

  if (stop.stop_time_type === StopTimeType.ASAP_DELIVERY) {
    return "";
  }

  if (stop.stop_time_type === StopTimeType.BEFORE) {
    return formatStopSummaryDateTime(stop.stop_before_date, stop.stop_before_time);
  }

  if (stop.stop_time_type === StopTimeType.BETWEEN) {
    const after = formatStopSummaryDateTime(stop.stop_after_date, stop.stop_after_time);
    const before = formatStopSummaryDateTime(stop.stop_before_date, stop.stop_before_time);
    if (after && before) return `${after} - ${before}`;
    return after || before;
  }

  return formatStopSummaryDateTime(stop.stop_after_date, stop.stop_after_time);
}

export type StopSummary = { location: string; dateTime: string } | null;

export function buildStopSummary(stop?: ScheduleStopValue, countryCode?: string): StopSummary {
  const location = formatStopLocation(stop, countryCode);
  const dateTime = formatStopScheduleDateTime(stop);
  return location || dateTime ? { location, dateTime } : null;
}
